function generateIdFromName(name) {
    return name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
}


const productosTejidosExclusivos = [

    {
        nombre: 'Tela Densend',
        colores: ['Medium Grey'],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/superPromociones/densend/1.jpg"),
            require("../../assets/img/productos/superPromociones/densend/1.jpg")
        ]
    },{
        nombre: 'Tela Dimout',
        colores: ['Dark Grey', 'Grey Ash', 'Mocha'],
        categoria: 'Telas Exclusivas',
        ancho: '2.50',
        images: [
            require("../../assets/img/productos/superPromociones/dimout/1.jpg"),
            require("../../assets/img/productos/superPromociones/dimout/1.jpg"),
            require("../../assets/img/productos/superPromociones/dimout/2.jpg"),
            require("../../assets/img/productos/superPromociones/dimout/3.jpg")
        ]
    },{
        nombre: 'Tela Dimout Ligth',
        colores: ['Ivory', 'Gris'],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/superPromociones/dimoutLigth/1.jpg"),
            require("../../assets/img/productos/superPromociones/dimoutLigth/1.jpg"),
            require("../../assets/img/productos/superPromociones/dimoutLigth/2.jpg"),
        ]
    },{
        nombre: 'Tela Soft',
        colores: ['Ivory', 'Canela', 'Gris'],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/superPromociones/soft/1.jpg"),
            require("../../assets/img/productos/superPromociones/soft/1.jpg"),
            require("../../assets/img/productos/superPromociones/soft/2.jpg"),
            require("../../assets/img/productos/superPromociones/soft/3.jpg"),
        ]
    }
].map(producto => ({
    ...producto,
    id: generateIdFromName(producto.nombre),
    slug: `${producto.nombre.toLowerCase().replace(/\s+/g, '-')}-${producto.categoria.toLowerCase().replace(/\s+/g, '-')}`
}));

export default productosTejidosExclusivos ;